<template>
    <div class="app-content content devcontent " >
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
                <div class="mb-1 rbac_main_container">
                    <div class="access_controll_header">
                      <ul class="nav nav-tabs card-header-tabs access_controll_header_ul mb-0" id="myTab" role="tablist">
                        <li class="nav-item tabs-item">
                          <a class="nav-link active" id="access-tab" data-toggle="tab" href="#access" role="tab" aria-controls="access" aria-selected="true" @click="getAccessTabData()">Access</a>
                        </li>
                        <li class="nav-item tabs-item">
                          <a class="nav-link" id="menu-tab" data-toggle="tab" href="#menu" role="tab" aria-controls="menu" aria-selected="false" @click="getMenuList(defaultProjectMenuid)">Menu</a>
                        </li>
                      </ul>
                    </div>
              
                    <div class="content-body">
                        <vue-element-loading
                        :active="isPermissionFormLoading"
                        color="#FF6700"
                        />
                    <div class="card-body" style="background-color: transparent;">
                      <div class="tab-content" id="myTabContent">
                        
                        <!-- Content for Access tab -->
                        <div class="tab-pane fade show active" id="access" role="tabpanel" aria-labelledby="access-tab">
                          <div class="access_page_data">
                            <div class="access_page_wraper">
                                <div class="d-flex align-center">
                                  <div class="icon_access"><i class="las la-file-alt"></i></div>
                                  <label class="font16_42 ml-2" for="projectName">Project</label>
                                </div>
                                <div class="right_side_wrapping">
                                  <div class="create_btn mr-2">
                                    <a data-toggle="modal" data-target="#projectModal" class="link-cta" href="#">Create</a>
                                  </div>
                                  <div class="input_fields">
                                      <div class="form-group-fields">
                                          <!-- <label class="form-label text-left w-100" for="projectName">Project <span class="requiredField">*</span></label> -->
                                          <treeselect id="projectName" placeholder="-- SELECT --" @input="handleProjectChange" v-model="selectedProject" :options="projectList" />
                                      </div>
                                  </div>
                                </div>

                            </div>
                            <div class="access_page_wraper">
                              <div class="d-flex align-center">
                                <div class="icon_access"><i class="las la-file-alt"></i></div>
                                <label class="font16_42 ml-2" style="width: 100px" for="roleName">Role Name</label>
                              </div>
                              <div class="right_side_wrapping">
                                <div class="create_btn mr-2">
                                  <a data-toggle="modal" data-target="#exampleModal" class="link-cta" href="#" >Create</a>
                                </div>
                                <div class="input_fields">
                                  <div class="form-group-fields">
                                    <!-- <label class="form-label text-left w-100" for="roleName">Role <span class="requiredField">*</span></label> -->
                                    <treeselect id="roleName" placeholder="-- SELECT --" @input="handleRoleChange" v-model="selectedRole" :options="roles" />
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div class="access_page_wraper" style="align-items: start; !important">
                              <div class="d-flex align-center">
                                <div class="icon_access"><i class="las la-file-alt"></i></div>
                                <label class="font16_42 ml-2" for="roleName">Permission/Menu</label>
                              </div>
                              <div class="right_side_wrapping">
                                <div class="create_btn mr-2">
                                  <a data-toggle="modal" data-target="#menuModal" class="link-cta" href="#" >Create </a>
                                </div>
                                <div class="input_fields">
                                  <div class="permission_checkbox_container" v-if="menus.length">
                                    <vue-element-loading :active="isPermissionsLoading" color="#FF6700"/>
                                    <template v-for="(menu, index) in menus">
                                      <div class="form-group">
                                        <input type="checkbox" :id="menu.name" v-model="menu.isChecked" @change="handleParentMenuCheck(menu.name)" />
                                        <label :for="menu.name" class="checkbox-label">{{menu.name}}</label>
                                      </div>
                                      <template v-for="(submenu, index2) in menu.auth_menus">
                                        <div style="padding-left: 20px;" class="submenu_chckname_list">
                                          <div class="">
                                            <input type="checkbox" :id="submenu.name" v-model="submenu.isChecked" @change="handleSubMenuCheck(menu, submenu.name)"/>
                                            <label :for="submenu.name" class="checkbox-label">{{submenu.name}}</label>
                                          </div>
                                        </div>
                                      </template>
                                    </template>
                                  </div>
                                  <div class="" v-else>
                                    <vue-element-loading :active="isPermissionsLoading" color="#FF6700"/>
                                  <div class="no_menus_show vue-treeselect__control">No Menus to show</div>
                                </div>

                              </div>

                            </div>
                          </div>

                          <div class="save_btn_container">
                            <button @click="savePermissions" class=" " :disabled="!validForm()">Save</button>
                          </div>
                        </div>
                        </div>
                         <!-- Content for Menu tab -->
                        <div class="tab-pane fade" id="menu" role="tabpanel" aria-labelledby="menu-tab">
                          <div class="grid-item grid-item--2 mb-2">
                            <div class="col-12 form-group-fields">
                                <label class="form-label text-left w-100" for="projectName">Project <span class="requiredField">*</span></label>
                                <treeselect id="projectName" placeholder="-- SELECT --" @input="handleSelectedProject" v-model="defaultProjectMenuid" :options="projectList" />
                            </div>
                        </div>
                            <vue-element-loading :active="isMenuListLoading" color="#FF6700"/>
                            <div class="table-responsive datatableview p-0 access_menu_data">
                                <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                                       v-if="listing_menus.length">
                                    <thead>
                                        <tr>
                                          <th class="text-left align-middle">Sub Menu </th>
                                          <th class="text-left align-middle">Name</th>
                                          <th class="text-left align-middle">Route Path</th>
                                          <th class="text-left align-middle">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      <template>
                                          <template v-for="(item,index) in listing_menus" >
                                                    <tr>
                                                        <td data-column="Sub Menu" class="text-left">
                                                          <button class="btn btn-link custom-teal" @click="showClickedSubmenu(index,item.parent_menu_id)" :disabled="!item.auth_menus.length">Show Submenu  <i :class="opentoggledBox === index ? 'las la-angle-up' : 'las la-angle-down'"></i></button>
                                                          
                                                        </td>
                                                        <td data-column="Name" class="text-left">{{ item.name }}</td>
                                                        <td data-column="Route Path" class="text-left">{{ item.route_path}}</td>
                                                        <td data-column="Action" class="text-left">
                                                            <i class="las la-edit" style="font-size: 25px; color: blue;" data-toggle="modal" data-target="#menuModal" @click="editMenuItem(index,item.parent_menu_id)"></i>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                      <td
                                                      class="p-0"
                                                      colspan="100"
                                                      style="padding: 0px !important">
                                                          <div :class="{ 'submenu-expanded': opentoggledBox === index && item.auth_menus.length }" class="submenu-box">
                                                          <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable submenu_table_list">
                                                              <thead>
                                                                  <tr>
                                                                    <th class="text-left align-middle">Sub-menu</th>
                                                                    <th class="text-left align-middle">Route Path</th>
                                                                  </tr>
                                                              </thead>
                                                              <tbody>
                                                                <tr v-for="(sub_menu,index) in item.auth_menus">
                                                                  <td 
                                                                    data-column="Sub-menu"
                                                                    class="text-left">
                                                                       {{ sub_menu.name }}
                                                                   </td>
                                                                  <td 
                                                                    data-column="Route Path"
                                                                    class="text-left">
                                                                       {{ sub_menu.route_path }}
                                                                  </td>
                                                                </tr> 
                                                              </tbody>
                                                          </table> 
                                                        </div>
                                                      </td>
                                                    </tr>
                                                    
                                          </template>
                                      </template>
                                      
                                    </tbody>
                                </table>
                                <div v-else>
                                    <tr>No Data Found</tr>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

               
              </div>
              <!-- ------------------------------------------- -->
              <!-- project create Modal box -->
              <div class="modal fade" id="projectModal" tabindex="-1" role="dialog" aria-labelledby="projectModalLabel" aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="projectModalLabel">Create Project</h5>
                      <button type="button" class="close-button" data-dismiss="modal" @click="toggleProjectCreateBox" aria-label="Close">
                        <span aria-hidden="true">x</span>
                      </button>
                    </div>
                    
                    <div class="modal-body">
                      <div class="form-group">
                         <input id="role"  class="form-control" type="text" v-model="newProjectField" placeholder="Enter Project Name"/>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="toggleProjectCreateBox">Close</button>
                      <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveProjectCreate" :disabled="!validProjectCreateFields()">Save </button>
                    </div>
                  </div>
                </div>
               </div>
              <!--  role create Modal box -->
              <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">Create Role</h5>
                      <button type="button" class="close-button" data-dismiss="modal" @click="toggleRoleCreateBox" aria-label="Close">
                        <span aria-hidden="true">x</span>
                      </button>
                    </div>
                    <!-- <vue-element-loading
                    :active="isRoleModalLoading"
                    spinner="bar-fade-scale"
                    /> -->
                    <div class="modal-body">
                      <div class="form-group">
                        <input id="role"  class="form-control" type="text" v-model="newRoleField" placeholder="Enter New Role"/>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="toggleRoleCreateBox">Close</button>
                      <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveNewRole" :disabled="!validRoleFields()">Save </button>
                    </div>
                  </div>
                </div>
               </div>
               <!-- permission/create  Modal box || update modal box-->
               <div class="modal fade bd-example-modal-lg" id="menuModal" tabindex="-1" role="dialog" aria-labelledby="menuModalLabel" aria-hidden="true"
              >
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content ">
                    <div class="modal-header">
                      <h5 class="modal-title h4" id="menuModalLabel">Create Menu</h5>
                      <button type="button" class="close-button" data-dismiss="modal" aria-label="Close" @click="togglePermissionCheckBox">
                          <span aria-hidden="true">x</span>
                      </button> 
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                   <label class="form-label text-left w-100" for="projectName">Project <span class="requiredField">*</span></label>
                                   <treeselect id="projectName" placeholder="-- SELECT --"  v-model="create_menu.project_id" :options="projectList" />
                                </div>
                                <div class="form-group col-md-6">
                                   <label class="form-label text-left w-100" for="parentmenu">Menu </label>
                                   <input id="parentmenu" class="form-control" v-model="create_menu.parentmenu" type="text" placeholder="Dashboard"/>
                                </div>
                            </div>
                            <div class="form-row">
                              <div class="form-group col-md-6" v-if="!create_menu.childmenus.length">
                                <label class="form-label text-left w-100" for="menuroutepath">Menu Route Path </label>
                                <input id="menuroutepath" class="form-control" v-model="create_menu.route_path" type="text" placeholder="path/to/page"/>
                              </div>
                                <div class="form-group col-md-6">
                                   <label class="form-label text-left w-100" for="menu_icon">Menu Icon</label>
                                   <input id="menu_icon" class="form-control" v-model="create_menu.menu_icon" type="text" placeholder="la-truck"/>                     
                                </div>
                            </div>
                            <div  v-for="(menu, index) in create_menu.childmenus" :key="index" class="form-row">
                                  <div class="form-group col-md-6">
                                     <label class="form-label text-left w-100" for="submenu">Sub Menu {{ index+1 }}</label>
                                     <input id="submenu" type="text" class="form-control" v-model="create_menu.childmenus[index].name" placeholder="Enter Sub Menu"/>
                                  </div>
                                  <div class="form-group col-md-4">
                                     <label class="form-label text-left w-100" for="submenuroutepath">Route Path {{ index+1 }}</label>
                                     <input id="submenuroutepath" type="text" class="form-control" v-model="create_menu.childmenus[index].route_path" placeholder="Enter Route Path"/>
                                  </div>
                                  <div class="form-group col-md-2">
                                    <p></p>
                                     <button @click="removeChildMenu(index)"  class="btn btn-outline-danger custom-button ">
                                      <i class="fa fa-times mastercreateicon"></i> 
                                     </button>
                                  </div>
                            </div>
                        </form>
                      
                        <!-- <div v-for="(menu, index) in create_menu.childmenus" :key="index" class="form-row">
                          <div>
                            
                            
                          </div>
                      </div> -->
                     
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-outline-primary mr-1 waves-effect  mr-1 submenu-button " @click="addNewTextbox" >
                          Add Sub menu
                          <i class="las la-plus mastercreateicon"></i>
                        </button>
                      <button type="button" class="btn btn-secondary" style="padding: 10px" data-dismiss="modal" @click="togglePermissionCheckBox">Close</button>
                      <button type="button" class="btn btn-primary" style="padding: 10px" data-dismiss="modal" @click="isUpdatedMenu ? updateMenusDetails() :saveNewPermissionMenus()" :disabled="!validPermissionFields()">Save </button>
                    </div>
                  </div>
                </div>
               </div>
            
            </div>
    </div>
</template>
<script>
import axios from 'axios'
import { EyeIcon } from 'vue-feather-icons'
import { EyeOffIcon } from 'vue-feather-icons'
import VueElementLoading from "vue-element-loading";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import common_methods from "../../utils/common_methods";
import searchMasterNameList from "../../utils/searchMasterNameList";

export default ({
    name: 'RBAC',
    mixins: [common_methods, searchMasterNameList],
    components: {
        EyeIcon,
        EyeOffIcon,
        VueElementLoading,
        Treeselect,
    },
    data(){
        return {
            username : null,
            isUpdatedMenu :false,
            opentoggledBox:null,
            isMenuListLoading :false,
            isProjectCreateModalLoading:false,
            isRoleModalLoading:false,
            isMenuModalLoading:false,
            isPermissionFormLoading:false,
            showParentMenuRoutePath:false,
            isPermissionsLoading: false,
            toggleRoleBox : false,
            showPermissionBox :false,
            newRoleField: null,
            newProjectField:null,
            create_menu:{
              parent_menu_id:null,
              parentmenu:null,
              childmenus:[],
              route_path:null,
              project_id:null,
              menu_icon: null,
            },
            selectedRole: null,
            selectedProject: null,
            defaultProjectMenuid:null,
            roles: [],
            projectList: [],
            permissions: {
                dashboard: false,
                entryLoadingControl: false,
                gateControl: false,
                dockControl: false,
                dailyTransaction: false,
                reports: false,
                report1: false,
            },
            menus: [],
            listing_menus:[]
        }
        
    },
    created() {
        this.defaultProjectMenuid = 1;
        this.getAllRoles()
        this.getProjects()
    },
    mounted() {
        let userdata  = window.localStorage.getItem('userdata');
        if(userdata) {
            userdata = JSON.parse(userdata);
            this.username = userdata.username
        }
    },
    methods: {
        handleSelectedProject(id){
           if(id && this.defaultProjectMenuid!==id){
            this.getMenuList(id)  
            this.defaultProjectMenuid = id;
          }
          this.getMenuList(this.defaultProjectMenuid)
        },
        editMenuItem(index,menu_id) {
          let selected_menu = this.listing_menus.find(obj=>obj.parent_menu_id===menu_id)
          this.isUpdatedMenu = true;
          this.togglePermissionCheckBox()
          this.create_menu.parentmenu = selected_menu.name;
          this.create_menu.childmenus = selected_menu.auth_menus;
          this.create_menu.route_path = selected_menu.route_path;
          this.create_menu.project_id = this.defaultProjectMenuid
          this.create_menu.parent_menu_id = menu_id;
        },
        showClickedSubmenu(index,id){
            if(this.opentoggledBox===index)
              this.opentoggledBox = null;
            else{
              this.opentoggledBox = index;
            }
            // console.log(index,id)
        },
        getMenuList(id){
          if(!id) {
            this.sweetAlertSnackbar("No Project selected", "warning")
            return
          }
          this.isMenuListLoading = true;
          let project_id = id;
          let url = `/rbac/menus/${project_id}`
          try {
              this.makeRequest("GET",url)
                  .then(result => {
                    this.listing_menus = result.data
                   })
                  .catch(e => {
                    this.displayError(e);
                   })
                   .finally(e => {
                     this.isMenuListLoading = false;
                   }) 
          }catch(e) {
              next(e)
          }
        },
        getAccessTabData() {
          this.getAllRoles()
          this.getProjects()
        },
        clearPermissionBox(){
          this.create_menu.parentmenu = null;
          this.create_menu.childmenus = [];
          this.create_menu.route_path = null;
          this.create_menu.project_id = null;
          this.create_menu.menu_icon = null;
        },
        removeChildMenu(index){
          this.create_menu.childmenus.splice(index, 1);
        },
        addNewTextbox() {
          this.create_menu.route_path = null;
          const allFilledUp= this.create_menu.childmenus.every(menu => {
          return menu.name !==null && menu.name.trim() !=='' &&
          menu.route_path !==null && menu.route_path.trim() !== ''
          });
          if(allFilledUp){
             this.create_menu.childmenus.push({name:"",route_path:""})
          }else{
             this.sweetAlertSnackbar("Please fill current menu details","error")
          }
        }, 
        removeTextbox(){

        },
        async getAllRoles(){
              try{
                this.isPermissionFormLoading = true
              let all_roles = await this.searchNameMasterList('auth_roles','role_name',null,'role_id')
              this.isPermissionFormLoading = false
              if(all_roles){
                console.log(all_roles.data)
                this.roles = all_roles.data;
              }else{
                this.sweetAlertSnackbar("Roles Not Found","error")
              }
              }catch(e){
                  next(e)
              }
        },
        getProjects() {
          this.isPermissionFormLoading = true
          this.searchNameMasterList('auth_projects', 'name', null, 'project_id')
              .then(result => {
                this.isPermissionFormLoading = false
                  this.projectList = result.data
              })
              .catch(e => {
                this.isPermissionFormLoading = false
                  this.displayError(e)
              })
        },
        validProjectCreateFields() {
          let isValid = true;
          if(!this.newProjectField){
             isValid = false;
          }
          return isValid;
        },
        validRoleFields() {
          let isValid = true;
          if(!this.newRoleField){
             isValid = false;
          }
          return isValid;
        },
        validPermissionFields(){
          let isValid = true;
          if(!this.create_menu.parentmenu){
            isValid = false;
          }
          if(!this.create_menu.project_id){
            isValid = false;
          }
          if(this.create_menu.childmenus.length){
            const allValid = this.create_menu.childmenus.every(menu => {
            return menu.name !== null && menu.name.trim() !== '' &&
                  menu.route_path !== null && menu.route_path.trim() !== '';
          });
          if(!allValid){
            isValid = false;
          }
          }else{
            if(!this.create_menu.route_path){
              isValid = false;
            }
          }
          if(!this.create_menu.menu_icon){
            isValid = false;
          }
          return isValid;
        },
        validForm(){
          let isValid = true;
          if(!this.selectedProject){
            isValid = false;
          }
          if(!this.selectedRole){
            isValid = false;
          }
          return isValid;
        },
        saveNewRole(){
          this.isPermissionFormLoading = true;
          if(!this.validRoleFields()) {
              this.sweetAlertSnackbar("Form was invalidated. Make sure that all reuired fields are filled out!", 'error')
              return
          }
          // console.log(this.newRoleField)
          try{
          let payload = {
              role_name : this.newRoleField
          }
          this.makeRequest("POST","/rbac/addrole",payload)
              .then(result=>{
                  this.isPermissionFormLoading = false;
                  this.newRoleField ="" 
                  // console.log(result)
                  if(result.data.status){
                    this.getAllRoles()
                    this.sweetAlertSnackbar(result.data.message,"success")
                  }else{
                    this.sweetAlertSnackbar(result.data.message,"error")
                  }
                })
              .catch(e=>{
                  this.isPermissionFormLoading = false;
                  this.newRoleField ="" 
                  this.displayError(e)
                })
          }catch(e){
            next(e)
          }
        },
        saveProjectCreate(){
           this.isPermissionFormLoading = true;
           //  console.log(this.newProjectField);
           if(!this.validProjectCreateFields()){
              this.sweetAlertSnackbar("Form was invalidated. Make sure that all reuired fields are filled out!", 'error')
              return
           }
           try{
              let payload = {
                  project_name: this.newProjectField,
                  useremail : this.username
              }
              // console.log(payload)
              this.makeRequest("POST","/rbac/addproject",payload)
                  .then(result=>{
                      this.isPermissionFormLoading = false;
                      // console.log(result.data); 
                      if(result.data.status){
                        this.getProjects()
                        this.sweetAlertSnackbar(result.data.message,"success")
                      }else{
                        this.sweetAlertSnackbar(result.data.message,"error")
                      }  
                   })
                  .catch(e=>{
                      this.isPermissionFormLoading = false;
                      this.displayError(e);
                   })

           }catch(e){
              next(e)
           }
        },
        saveNewPermissionMenus(){
          this.isPermissionFormLoading = true;
          if(!this.validPermissionFields()) {
                  this.sweetAlertSnackbar("Form was invalidated. Make sure that all reuired fields are filled out!", 'error')
                  return
              }
          let payload = {
            project_id:this.create_menu.project_id,
            parent_menu_name:this.create_menu.parentmenu,
            route_path:this.create_menu.route_path,
            menu_icon: this.create_menu.menu_icon,
            menus:this.create_menu.childmenus
          }
          // console.log(payload)
          try{
          this.makeRequest("POST","/rbac/menus",payload)
              .then(result=>{
                  this.isPermissionFormLoading = false;
                  // console.log(result)
                  if(result.data.status){
                      this.sweetAlertSnackbar(result.data.message,"success")
                      this.getPermissions(this.selectedRole, this.selectedProject)
                  }else{
                      
                      this.sweetAlertSnackbar(result.data.message,"error")
                  }
               })
              .catch(e=>{
                  this.isPermissionFormLoading = false;
                  this.displayError(e)
               })
          }catch(e){
            next(e)
          }
          
        },
        updateMenusDetails(){
          this.isMenuListLoading = true;
          let payload = {
            project_id:this.create_menu.project_id,
            parent_menu_id:this.create_menu.parent_menu_id,
            parent_menu_name:this.create_menu.parentmenu,
            route_path:this.create_menu.route_path,
            menu_icon: this.create_menu.menu_icon,
            menus:this.create_menu.childmenus
          }
          console.log(payload)
          try{
          this.makeRequest("PUT","/rbac/updatemenus",payload)
              .then(result=>{
                  this.isMenuListLoading = false;
                  // console.log(result)
                  if(result.data.status){
                      this.sweetAlertSnackbar(result.data.message,"success")
                  }else{
                      this.sweetAlertSnackbar(result.data.message,"error")
                  }
                  this.getMenuList(this.defaultProjectMenuid)
               })
              .catch(e=>{
               
                  this.isMenuListLoading = false;
                  this.displayError(e)
               })
               this.isUpdatedMenu = false;
          }catch(e){
            next(e)
          }
        },
        toggleRoleCreateBox(){
          this.newRoleField = ""
          
        },
        toggleProjectCreateBox(){
          this.newProjectField = null;
        },  
        getPermissions(role_id, project_id) {
              this.isPermissionsLoading = true
              this.makeRequest("GET", `/user/rbac?role_id=${role_id}&project_id=${project_id}`)
              .then(result => {
                  this.menus = result.data
                  })
               .catch(e => {
                  this.displayError(e)
                  })
               .finally(() => {
                  this.isPermissionsLoading = false
                  })
                // this.toggleRoleBox = !this.toggleRoleBox
                // if(this.toggleRoleBox){
                //   $('#exampleModal').modal('hide');
                // }else{
                //   $('#exampleModal').modal('show');
                // }
        }, 
        togglePermissionCheckBox(){
          this.clearPermissionBox()
        } ,

        savePermissions() {
          this.isPermissionFormLoading = true;
          const rolePermissions = {
            role_id: this.selectedRole,
            permissions: this.menus,
           };
          console.log(rolePermissions);
          // Add your logic to save permissions
          this.makeRequest('PUT', '/user/rbac', rolePermissions)
              .then(result => {
                  this.isPermissionFormLoading = false;
                  console.log(result)
              })
              .catch(e => {
                  this.isPermissionFormLoading = false;
                  this.displayError(e)
              }) 
        },
        handleParentMenuCheck(id) {
            let currentMenu = this.menus.find(menu => menu.name === id)
            if(currentMenu && currentMenu.auth_menus.length) {
                for(let menu of currentMenu.auth_menus) {
                    menu.isChecked = currentMenu.isChecked
                }
            }
        },
        handleSubMenuCheck(menu, subMenuName) {
          console.log(menu)
            let isAllDeselected = menu.auth_menus.every(item => !item.isChecked)
            console.log(isAllDeselected)
            if(isAllDeselected) {
              menu.isChecked = false
            } else {
              menu.isChecked = true
            }

            // let currentSubMenu = this.menus.find(menu => {
            //     if(menu.auth_menus.length) {
            //         let submenu = menu.auth_menus.find(submenu => submenu.name === id)
            //         if(submenu) {
            //             return true
            //         }
            //     }
            // })
            // if(currentSubMenu && currentSubMenu.au)
            // console.log(currentSubMenu)
        },
        handleRoleChange(id) {
            if(id && this.selectedProject) {
                this.getPermissions(id, this.selectedProject)
            } else {
                this.menus = []
            }
        },
        handleProjectChange(id) {
            if(id && this.selectedRole) {
                this.getPermissions(this.selectedRole, id)
            } else {
                this.menus = []
            }
        }

    }
})
</script>

<style scoped>
.grid {
  display: grid;
  width: 80%;
  margin: auto;
  grid-template-columns: 1fr 2fr;
  gap: 10px;
}

.grid-item--1 {
  background-color: #f9f9f9;
  padding: 10px;
}

.grid-item--2 {
  background-color: #f1f1f1;
  padding: 10px;
}

.grid-item--full {
  grid-column: 1 / -1;
  text-align: center;
}


.checkbox-label {
  margin-left: 5px;
}

.save-button {
  margin-top: 20px;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.save-button:hover {
  background-color: #0056b3;
}

.form-group {
  margin-bottom: 15px;
}
.submenu-button {
  padding: 10px 20px;
  margin-right: 10px;  
  float: left;    
  width: auto;
}
.custom-button {
  margin: 10px 5px;
  padding: 5px 10px;
  }
.close-button {
     background-color: transparent;
     border: none;
     color: #807f7f;
     font-size: 1.5rem;
     font-weight: bold;
     cursor: pointer;
}

.close-button:hover {
        color: #999; 
    }

.custom-teal {
  color: #008080; 
}


.custom-teal:hover {
  color: #005454;
  text-decoration: none;
}
</style>